module.exports = __webpack_public_path__ + "static/media/01-galeria-04-suarez@2x.284a8fac.jpg";